@if (displayErrors && !isValid) {
  <div class="ui-input__error-wrapper">
    <p class="ui-input__error">{{ getErrorMessage(errorEntries[0]) }}</p>
    <pxw-icon class="ui-input__error-icon" icon="info" size="sm" />
  </div>
}
